import { Resolver } from "react-hook-form";
import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgramPaymentType } from "../../../../types/dto/program";
import { programPaymenAcademy, programsStudentAcademy } from "../../../../shared/services";
import useProgramStudent from "../students/useProgramStudent";
import { message } from "antd";
import moment from "moment";

export interface UseCreateProgramScheduleProps {
  programId: number;
  scheduleId: number;
  setOpenModal: (value: boolean) => void;
}

export default function useCreatePayment({ programId, scheduleId, setOpenModal }: UseCreateProgramScheduleProps) {
  const [loading, setLoading] = React.useState(false);

  const { control, handleSubmit: onSubmit, reset } = useForm<ProgramPaymentType>({
    resolver: yupResolver(
      yup.object({
        user_id: yup.string().required('Campo requerido'),
        amount: yup.string().required('Campo requerido'),
        payment_date: yup.string().required('Campo requerido'),
      })
    ) as unknown as Resolver<ProgramPaymentType>,
  });

  const handleSubmit = onSubmit(async (data) => {
    if (loading) return;

    try {

      const {data: programStudent} = await programsStudentAcademy.find({
        query: { program_id: programId, user_id: +data.user_id },
      });

      if (programStudent.length === 0) {
        return message.error('Acción no permitida, primero debes inscribir al estudiante en el programa')
      }
    
        setLoading(true);
        await programPaymenAcademy.create({
          user_id: +data.user_id,
          program_payment_schedule_id: +scheduleId,
          program_id: +programId,
          program_student_id: programStudent[0].id,
          payment_date: moment(data.payment_date),
          amount: +data.amount,
          payment_concept: "cuota",
        }).then(()=>setOpenModal(false))
        reset();        
        message.success("Pago creado exitosamente");        
    } catch (err) {
      message.error("Error al crear el pago");
    } finally {
      setLoading(false);
    }
  });

  return {
    control,
    loading,
    handleSubmit,
  };
}
